import "fslightbox";
import "leaflet/dist/leaflet.css";
import "./carousel";
import "./navigation";
import "./sentry";

window.addEventListener("cc:onChange", () => location.reload());
